module.exports = "/assets/landing-rwx/how-it-works/step_2@2x.png?O9NG+2u";